const HOSTINGS = ["Riad Zorni", "Kasbah Lodge", "Auberge du Sud", "Villa Oasis", "Écolodge Atlas"];

function numericIdOf(id = "") {
  return parseInt(id.replace(/\D/g, ""), 10) || 0;
}

function nbDaysFromDuree(duree = "") {
  const match = duree.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : 1;
}

function addDays(base, days) {
  const dt = new Date(base);
  dt.setDate(dt.getDate() + days);
  return dt.toISOString();
}

function roundToHundred(value) {
  return Math.round(value / 100) * 100;
}

function destinationParts(destination = "") {
  const [city, country] = destination.split(",").map((s) => s.trim());
  return { city: city || destination, country: country || "—" };
}

function cityFromStepText(text, fallbackCity) {
  const cleaned = text.replace(/^J\d+\s*[·-]\s*/i, "").trim();
  const match = cleaned.match(/\bà\s+([A-ZÀ-Ý][\wÀ-ÿ'’\- ]+)$/);
  if (match) return { city: match[1].trim(), description: cleaned };
  if (cleaned.split(" ").length <= 4) return { city: cleaned, description: cleaned };
  return { city: fallbackCity, description: cleaned };
}

// Génère un visuel de couverture (pas de vraie photo en mock) — dégradé + nom du circuit.
export function buildHeroImageDataUri(c) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="900" height="360">
    <defs>
      <linearGradient id="g" x1="0" x2="1" y1="0" y2="1">
        <stop offset="0" stop-color="#4F46E5"/>
        <stop offset="1" stop-color="#0D9488"/>
      </linearGradient>
    </defs>
    <rect width="900" height="360" fill="url(#g)"/>
    <text x="40" y="200" font-family="sans-serif" font-size="34" font-weight="700" fill="#ffffff">${c.nom}</text>
    <text x="40" y="236" font-family="sans-serif" font-size="18" fill="rgba(255,255,255,.85)">${c.destination}</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function deriveTripView(c, etablissement) {
  const numericId = numericIdOf(c.id);
  const nbDays = nbDaysFromDuree(c.duree);
  const { city: destinationCity, country } = destinationParts(c.destination);

  const summary = c.description || `Circuit ${c.duree} proposé par ${c.etab}.`;
  const details = `Circuit organisé par ${c.etab} au départ de ${c.destination}, ${c.duree}. Consultez le programme détaillé ci-dessous pour l'itinéraire complet.`;

  const programme = c.programme?.length ? c.programme : [`Séjour à ${destinationCity}`];

  const offsets = [21, 45, 75];
  const dates = offsets.map((offset, index) => {
    const startDate = addDays(new Date(), offset);
    const endDate = addDays(startDate, Math.max(nbDays - 1, 0));
    const discount = index === 1 ? 0.9 : 1;
    const adultPrice = roundToHundred(c.prix * discount);
    return {
      id: `${c.id}-D${index + 1}`,
      startDate,
      endDate,
      nbDays,
      adultPrice,
      childPrice: roundToHundred(c.prix * 0.7 * discount),
      babyPrice: roundToHundred(c.prix * 0.15 * discount),
      stock: 4 + ((numericId + index * 7) % 16),
      manager: etablissement?.responsable || c.etab,
      isCheapestDate: index === 1,
      // Planning des étapes pour ce départ précis (comme stepDatesByStepId côté zorni-portal)
      stepDates: programme.map((_, stepIndex) => (stepIndex < nbDays ? addDays(startDate, stepIndex) : null)),
    };
  });
  const steps = programme.map((text, index) => {
    const rank = index + 1;
    const { city, description } = cityFromStepText(text, destinationCity);
    const seed = numericId + rank;
    return {
      id: `${c.id}-S${rank}`,
      rank,
      city,
      country,
      description,
      hosting: { name: HOSTINGS[seed % HOSTINGS.length], stars: 3 + (seed % 3) },
      activities: [
        { id: `${c.id}-S${rank}-A1`, title: description, isIncluded: true, price: 0 },
        { id: `${c.id}-S${rank}-A2`, title: "Excursion optionnelle", isIncluded: false, price: 1500 + rank * 500 },
      ],
      options: [{ id: `${c.id}-S${rank}-O1`, title: "Transfert privé", price: 2000 + rank * 300 }],
    };
  });

  return {
    heroImage: buildHeroImageDataUri(c),
    summary,
    details,
    childsMaxAge: 12,
    babiesMaxAge: 2,
    dates,
    steps,
  };
}

export default deriveTripView;
